import { Buffer } from 'buffer'

/**
 * Decode a JWT payload without signature verification.
 * Returns the parsed payload object, or null if the token is malformed.
 */
export function decodeJwtPayload (token: string): any {
    const parts = token.split('.')
    if (parts.length !== 3) {
        console.error('[decodeJwtPayload] Invalid token format')
        return null
    }

    try {
        // JWT payloads use base64url encoding (RFC 7515): - instead of +, _ instead of /,
        // no padding. Normalize to standard base64 since buffer@4.x lacks 'base64url' support.
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(Buffer.from(base64, 'base64').toString('utf8'))
    } catch (error) {
        console.error('[decodeJwtPayload] Could not parse token payload')
        return null
    }
}
